module.exports = __webpack_public_path__ + "12472769.png";